module.exports = __webpack_public_path__ + "img/homeMask.e7dcf741.png";